import angular from 'angular';
import i18n from '../i18n';

import spinnerDirective from './spinner-directive';

/**
 * @ngdoc module
 * @name akamai.components.spinner
 *
 * @guideline https://design.akamai.com/components/numeric-spinner/
 *
 * @requires module:akamai.components.i18n
 *
 * @description
 * Spinner is a form control that combines a numeric input field and arrow controls to increment or
 * decrement the value in the field. It also accepts keyboard input with filtering to ensure that
 * input is valid and within a defined range.
 *
 * @example index.html
 * <akam-spinner
 *   min="0"
 *   max="99"
 *   custom-step="2"
 *   placeholder="custom.i18n.key"
 *   ng-model="numberValue"
 *   is-disabled="disabled"
 *   is-readonly="readonly">
 * </akam-spinner>
 *
 */
export default angular.module('akamai.components.spinner', [
  i18n.name
])

/**
 * @ngdoc directive
 * @name akam-spinner
 *
 * @description Creates a spinner control with support for integer and float values.
 *
 * @param {number} ngModel The spinner value
 *
 * @param {number} [max] The upper bound value
 *
 * @param {number} [min] The lower bound value
 *
 * @param {number} [custom-step=1] The value used to increment/decrement the spinner value.
 *
 * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
 *
 * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
 * text will be easier to read.
 *
 * @param {string|TranslateKey} [placeholder=""] The placeholder text to show within the input
 */
  .directive('akamSpinner', spinnerDirective);
